/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Skill_OkInputs */

const en_mk_tut_skill_ok = /** @type {(inputs: Mk_Tut_Skill_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The next run’s transcript shows a \`load_skill\` line — proof the agent really read it.`)
};

const id_mk_tut_skill_ok = /** @type {(inputs: Mk_Tut_Skill_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di transkrip run berikutnya terlihat baris \`load_skill\` — bukti agen benar-benar membacanya.`)
};

/**
* | output |
* | --- |
* | "The next run’s transcript shows a `load_skill` line — proof the agent really read it." |
*
* @param {Mk_Tut_Skill_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_skill_ok = /** @type {((inputs?: Mk_Tut_Skill_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Skill_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_skill_ok(inputs)
	return en_mk_tut_skill_ok(inputs)
});